// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { AufgabePromptDaten, type Prompt } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type CreateAufgabePromptQuery = { activate?: boolean };

export function useCreateAufgabePrompt(): (
  aufgabeId: string,
  query: CreateAufgabePromptQuery,
  requestBody: AufgabePromptDaten
) => Promise<Prompt> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, query = {}, requestBody) =>
      (await getAPI()).prompts.createAufgabePrompt({
        aufgabeId,
        ...query,
        requestBody,
      }),
    [getAPI]
  );
}
